export const handleRequest = async (
  requestFn,
  defaultErrorMsg = 'Erro na requisição'
) => {
  try {
    const response = await requestFn();

    return {
      status: response.status,
      data: response.data,
      error: null,
    };
  } catch (error) {
    
    let message =
      error.response?.data?.message ||
      error.response?.data?.error ||
      defaultErrorMsg;

    // Erros sem resposta do servidor
    if (!error.response) {
      switch (error.code) {
        case 'ERR_NETWORK':
          message = 'Não foi possível conectar ao servidor';
          break;

        case 'ECONNABORTED':
          message = 'Tempo limite da requisição excedido';
          break;

        default:
          message = error.message || 'Erro de conexão';
      }
    }

    return {
      status: error.response?.status || 0,
      data: null,
      error: message,
    };
  }
};